import React from 'react'
import { Filter } from '@adc/ui-core'
import type { FilterProps } from '@adc/ui-core'

export type SmallFilterProps = Omit<FilterProps, 'size'>

/**
 * SmallFilter
 * A wrapper component around Filter with hardcoded 'small' size.
 * This provides a consistent small-sized filter toolbar across the Morpheus applications.
 */
const SmallFilter: React.FC<SmallFilterProps> = props => {
  return <Filter {...props} size='small' />
}

export default SmallFilter
